import { apiHelper } from '@/utils';
import { API } from '@/constants';
import { sportClubSportTypeService } from '@/services/api/sportClubSportType.service';
import { sportClubBoardTypeService } from '@/services/api/sportClubBoardType.service';

const API_URL = `${API.BASE_URL_API}/v1`;
export const sportClubService = { getAll, show, store, update, updateStatus, getOptions };

export function getAll(filter = {}) {
    const request = {
        params: {
            page: filter?.pageNumber,
            size: filter?.pageSize,
        },
    };

    if (filter?.isActive !== undefined && filter?.isActive !== null && filter?.isActive !== -1 && filter?.isActive !== '') {
        request.params.is_active = filter.isActive;
    }

    if (filter?.sortBy) request.params.sortBy = filter.sortBy;
    if (filter?.orderBy) request.params.orderBy = filter.orderBy;

    let array = filter?.searchArray;
    array?.forEach((word, index) => {
        if (word != null && word !== '') {
            request.params[`search_words[${index}]`] = word;
        }
    });

    return apiHelper(API_URL).get('/sport-clubs', request);
}

export function show(uuid) {
    return apiHelper(API_URL).get(`/sport-clubs/${uuid}`);
}

export function toFormData(data, method) {
    const form = new FormData();
    form.append('name', data.name);
    form.append('sport_type_uuid', data.sportTypeUUID);
    form.append('description', data.description || '');
    if (method) form.append('_method', method);
    if (data.coverImage instanceof File) form.append('cover_image', data.coverImage);
    (data.boards || []).forEach((board, index) => {
        if (board.uuid) form.append(`boards[${index}][uuid]`, board.uuid);
        form.append(`boards[${index}][board_type_uuid]`, board.boardTypeUUID);
        form.append(`boards[${index}][ihextar_user_uuid]`, board.userUUID);
    });
    return form;
}

export function store(data) {
    return apiHelper(API_URL).post('/sport-clubs', toFormData(data));
}

export function update(data) {
    // Laravel accepts file uploads on POST with a PUT method override.
    return apiHelper(API_URL).post(`/sport-clubs/${data.uuid}`, toFormData(data, 'PUT'));
}

export function updateStatus(data) {
    return apiHelper(API_URL).patch(`/sport-clubs/${data.uuid}`, { is_active: data.isActive });
}

async function allOptions(service) {
    const options = [];
    let page = 1;
    let lastPage = 1;
    do {
        const response = await service.getAll({ pageNumber: page, pageSize: 100, isActive: 1 });
        options.push(...(response.data || []));
        lastPage = response.pagination?.last_page || 1;
        page++;
    } while (page <= lastPage);
    return options;
}

export async function getOptions() {
    const [sportTypes, boardTypes, usersResponse] = await Promise.all([
        allOptions(sportClubSportTypeService),
        allOptions(sportClubBoardTypeService),
        apiHelper(API_URL).get('/lookup/users'),
    ]);
    return {
        sportTypes,
        boardTypes,
        users: usersResponse.data || [],
    };
}
